<template>
  <b-form
    class="filter-rate-form justify-content-center align-items-start mb-3"
    inline
  >
    <div class="mr-3">
      <b-form-checkbox id="checkbox-1" name="checkbox-1" v-model="selectStock">
        <b-input-group prepend="股票代號" class="mb-2">
          <b-form-input
            :id="'stock-symbol'"
            :type="'number'"
            :disabled="!selectStock"
            :value="stockSymbolInForm"
            @change="$emit('change:stockSymbolInForm', $event)"
          ></b-form-input>
        </b-input-group>
      </b-form-checkbox>
    </div>
    <div class="mr-3">
      <b-form-checkbox id="checkbox-2" v-model="selectEBOIC" name="checkbox-2">
        <input-group
          :id="'EBOIC'"
          :prepend="'EBOIC'"
          :state="validationOfEBOIC"
          pattern="(^-?[1-9]\d+$)|(^-?[1-9]$)|(^0$)"
          :title="'請重新輸入整數(正或負)'"
          :disabled="!selectEBOIC"
          :value="EBOIC"
          @change="$emit('change:EBOIC', $event)"
        />
      </b-form-checkbox>
      <b-form-checkbox id="checkbox-3" v-model="selectROIC" name="checkbox-3">
        <input-group
          :id="'ROIC'"
          :prepend="'ROIC'"
          :state="validationOfROIC"
          pattern="(^-?[1-9]\d+$)|(^-?[1-9]$)|(^0$)"
          :title="'請重新輸入整數(正或負)'"
          :disabled="!selectROIC"
          :value="ROIC"
          @change="$emit('change:ROIC', $event)"
        />
      </b-form-checkbox>
    </div>
    <div class="mr-3">
      <b-form-checkbox
        id="checkbox-4"
        v-model="selectProfitRatio"
        name="checkbox-4"
      >
        <input-group
          :id="'gross-profit-ratio'"
          :prepend="'毛利率'"
          :state="validationOfGrossProfitRatio"
          pattern="(^-?[1-9]\d+$)|(^-?[1-9]$)|(^0$)"
          :title="'請重新輸入整數(正或負)'"
          :disabled="!selectProfitRatio"
          :value="GPR"
          @change="$emit('change:GPR', $event)"
        />
      </b-form-checkbox>
      <div class="d-flex">
        <!-- 下面這個 checkbox 是為了排版，在畫面是 hidden -->
        <input type="checkbox" class="checkbox-5 mr-2" />
        <input-group
          :id="'expected-rate-of-return'"
          :prepend="'預期投報'"
          :state="validationOfExpectedRateOfReturn"
          pattern="[1-9]{1}|\d{2,}|\d+\.\d+"
          :title="'請重新輸入大於 0.1 正數'"
          :value="ERR"
          @change="$emit('change:ERR', $event)"
        />
      </div>
    </div>
    <div class="mr-3">
      <b-input-group prepend="等級" class="mb-2">
        <b-form-select
          id="form-select-level"
          :value="Level"
          @change="$emit('change:Level', $event)"
          :options="[
            { text: 'A', value: 'A' },
            { text: 'B', value: 'B' },
            { text: 'C', value: 'C' },
            { text: 'D', value: 'D' },
            { text: '-', value: '' },
            { text: 'All', value: 'All' }
          ]"
        >
          <template v-slot:first>
            <b-form-select-option :value="null" disabled
              >-- 請選擇級別 --</b-form-select-option
            >
          </template>
        </b-form-select>
      </b-input-group>
      <b-input-group prepend="狀態" class="mb-2">
        <b-form-select
          id="form-select-companyType"
          :value="companyType"
          @change="$emit('change:companyType', $event)"
          :options="[
            { text: '上市', value: '1' },
            { text: '下市', value: '0' },
            { text: 'All', value: 'All' }
          ]"
        >
          <template v-slot:first>
            <b-form-select-option :value="null" disabled
              >-- 請選擇級別 --</b-form-select-option
            >
          </template>
        </b-form-select>
      </b-input-group>
    </div>
    <div class="d-flex flex-column">
      <b-button class="mb-2" type="button" variant="primary" @click="filter"
        >挑選</b-button
      >
      <b-button
        type="button"
        variant="primary"
        @click="$emit('submitAllCompany')"
        >看所有公司</b-button
      >
    </div>
  </b-form>
</template>

<script>
import InputGroup from "@/components/FilterByRate/InputGroup.vue";

export default {
  name: "FilterRateForm",
  components: {
    InputGroup
  },
  props: {
    EBOIC: {
      type: Number,
      required: true
    },
    ROIC: {
      type: Number,
      required: true
    },
    GPR: {
      type: Number,
      required: true
    },
    ERR: {
      type: Number,
      required: true
    },
    Level: {
      type: String,
      required: true
    },
    companyType: {
      type: [String, Boolean, Number]
    },
    stockSymbolInForm: {
      type: String
    }
  },
  data() {
    return {
      selectStock: false,
      selectEBOIC: false,
      selectROIC: false,
      selectProfitRatio: false
    };
  },
  watch: {
    selectStock(newVal) {
      this.$store.commit("selectedStockAtFilterOptions", newVal);
      if (newVal) {
        /**
         * 當選擇用 股票代號 過濾列表，
         * reset and disabled EOBIC、ROIC、毛利率
         */
        this.$emit("change:EBOIC", 0);
        this.$emit("change:ROIC", 0);
        this.$emit("change:GPR", 0);
        this.selectEBOIC = false;
        this.selectROIC = false;
        this.selectProfitRatio = false;
        this.$store.commit("selectedEBOICAtFilterOptions", this.selectEBOIC);
        this.$store.commit("selectedROICAtFilterOptions", this.selectROIC);
        this.$store.commit(
          "selectProfitRatioAtFilterOptions",
          this.selectProfitRatio
        );
      } else {
        /**
         * 當取消用 股票代號 過濾列表，
         * reset 股票代號
         */
        this.$emit("change:stockSymbolInForm", "");
      }
    },
    selectEBOIC(newVal) {
      this.$store.commit("selectedEBOICAtFilterOptions", newVal);
      if (newVal) {
        /**
         * 當選擇用 EBOIC 過濾列表
         */
        this.resetAndDisabledStock();
      } else {
        /**
         * 當取消用 EBOIC 過濾列表，
         * reset EOBIC
         */
        this.$emit("change:EBOIC", 0);
      }
    },
    selectROIC(newVal) {
      this.$store.commit("selectedROICAtFilterOptions", newVal);
      if (newVal) {
        /**
         * 當選擇用 ROIC 過濾列表
         */
        this.resetAndDisabledStock();
      } else {
        /**
         * 當取消用 ROIC 過濾列表，
         * reset ROIC
         */
        this.$emit("change:ROIC", 0);
      }
    },
    selectProfitRatio(newVal) {
      this.$store.commit("selectProfitRatioAtFilterOptions", newVal);
      if (newVal) {
        /**
         * 當選擇用 毛利率 過濾列表
         */
        this.resetAndDisabledStock();
      } else {
        /**
         * 當取消用 毛利率 過濾列表，
         * reset 毛利率
         */
        this.$emit("change:GPR", 0);
      }
    }
  },
  computed: {
    // :state 驗證機制，成功與錯誤輸入及時過濾，優化使用者介面。
    validationOfEBOIC() {
      const regex = /(^-?[1-9]\d+$)|(^-?[1-9]$)|(^0$)/;
      return regex.test(this.$store.getters.outputValueOfEBOIC);
    },
    validationOfGrossProfitRatio() {
      const regex = /(^-?[1-9]\d+$)|(^-?[1-9]$)|(^0$)/;
      return regex.test(this.$store.getters.outputValueOfGrossProfitRatio);
    },
    validationOfROIC() {
      const regex = /(^-?[1-9]\d+$)|(^-?[1-9]$)|(^0$)/;
      return regex.test(this.$store.getters.outputValueOfROIC);
    },
    validationOfExpectedRateOfReturn() {
      return this.$store.getters.outputValueOfExpectedRateOfReturn >= 0.1;
    }
  },
  methods: {
    resetAndDisabledStock() {
      this.$emit("change:stockSymbolInForm", "");
      this.selectStock = false;
      this.$store.commit("selectedStockAtFilterOptions", this.selectStock);
    },
    filter() {
      const queryData = this.$store.getters
        .whatQueryDataToGetBySelectedFilterOptions;
      if (!queryData.query) {
        this.$emit(queryData.emitName);
      } else {
        this.$emit(queryData.emitName, queryData.query);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#form-select-level,
#form-select-companyType {
  border-color: #007bff;
  max-width: 80px;
}
.input-group-text {
  width: 90px;
}
/deep/ .checkbox-5 {
  width: 16px;
  height: 16px;
  visibility: hidden;
}
</style>
